import script from "./DirectoryDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectoryDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./DirectoryDetailPage.vue?vue&type=style&index=0&id=323af190&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-323af190"]])

export default __exports__